import { ASC } from 'common/constants/analyst-dashboards';

/**
 * Compare two values for sorting, handling null/undefined values by placing them at the end.
 * @param aValue - First value to compare
 * @param bValue - Second value to compare
 * @param direction - Sort direction ('asc' or 'desc')
 * @returns Comparison result (-1, 0, or 1) adjusted for sort direction
 */
export const compareValuesForSort = (
  aValue: string | number | null | undefined,
  bValue: string | number | null | undefined,
  direction: string
): number => {
  // Handle null/undefined values - put them at the end
  if (aValue === null || aValue === undefined) {
    if (bValue === null || bValue === undefined) {
      return 0; // Both are null
    }
    return 1; // a is null, b is not - a goes after b
  }
  if (bValue === null || bValue === undefined) {
    return -1; // b is null, a is not - b goes after a
  }

  // Compare values based on type
  let comparison = 0;
  if (typeof aValue === 'number' && typeof bValue === 'number') {
    comparison = aValue - bValue;
  } else if (typeof aValue === 'string' && typeof bValue === 'string') {
    comparison = aValue.localeCompare(bValue);
  } else {
    // Mixed types - convert to string
    comparison = String(aValue).localeCompare(String(bValue));
  }

  if (comparison === 0) {
    return 0;
  }
  return direction === ASC ? comparison : -comparison;
};
